import { computed, nextTick, ref, watch } from 'vue'
import type { ComputedRef, ShallowRef } from 'vue'

// Base left offset (12) + icon width (16) + icon/scope gap (6) + buffer (8).
const BADGE_SURROUNDING_SPACE_PX = 42

interface UseScopeBadgePaddingReturn {
  badgePaddingStyle: ComputedRef<{ paddingLeft: string } | { paddingLeft?: never }>
}

/** Left padding that keeps typed text clear of the scope badge rendered inside a search input. */
export function useScopeBadgePadding(
  badge: Readonly<ShallowRef<HTMLElement | null>>,
  scope: () => string
): UseScopeBadgePaddingReturn {
  const badgeOffset = ref(0)

  const measureBadge = () => {
    badgeOffset.value =
      scope() && badge.value ? badge.value.offsetWidth + BADGE_SURROUNDING_SPACE_PX : 0
  }

  watch(
    scope,
    async () => {
      await nextTick()
      measureBadge()
    },
    { immediate: true }
  )

  /** Inline style for the input: empty until a badge has been measured. */
  const badgePaddingStyle = computed(() =>
    badgeOffset.value > 0 ? { paddingLeft: `${badgeOffset.value}px` } : {}
  )

  return { badgePaddingStyle }
}
